// extracted by mini-css-extract-plugin
module.exports = {"pageSection":"video-module--pageSection--1ERqB","sectionHeaderText":"video-module--sectionHeaderText--3akdl","videoContainer":"video-module--videoContainer--2_EWy"};